// gatsby-browser.js
// Этот файл используется для браузерных API Gatsby
// Для добавления мета-тегов используем gatsby-ssr.js

// Глобальные стили (единый шрифт, box-sizing, сброс отступов).
import './src/styles/global.css';

// Постоянная оболочка с боковым меню (монтируется один раз, не мигает при
// переходах). Реэкспорт общего обработчика — он же подключён в gatsby-ssr.js.
export { wrapPageElement } from './wrap-page-element';

// Переход между страницами инструментов (/ai-photo/<slug>/): прокруткой управляет сам
// инструмент — Чат-студия до первой отрисовки встаёт на низ треда, остальные наверх
// (ToolRenderer). Сброс Gatsby в 0 приходит из componentDidUpdate ScrollHandler'а, который
// выше по дереву, и давал кадр ленты сверху, а следом прыжок вниз («всё дрожит и прыгает»).
// undefined — поведение Gatsby по умолчанию для всех остальных переходов.
const TOOL_PAGE = /^\/ai-photo\/[^/]+\/?$/;
export const shouldUpdateScroll = ({ prevRouterProps, routerProps: { location } }) => {
  const prev = prevRouterProps && prevRouterProps.location;
  if (prev && TOOL_PAGE.test(prev.pathname) && TOOL_PAGE.test(location.pathname) && !location.hash) {
    return false;
  }
  return undefined;
};

// Восстановление при сбое загрузки JS-чанка.
// Чанк может не загрузиться, если nginx вернул 502 в момент перезапуска
// gatsby serve, либо после нового деплоя (изменились хэши имён файлов).
// В этом случае один раз перезагружаем страницу — это подтягивает свежие
// чанки. Флаг в sessionStorage защищает от бесконечного цикла перезагрузок.
const CHUNK_RELOAD_KEY = 'airun_chunk_reload_at';

const isChunkLoadError = (message) => {
  if (!message) return false;
  return (
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module')
  );
};

const reloadOnce = () => {
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    // Перезагружаем не чаще раза в 10 секунд, чтобы не зациклиться.
    if (Date.now() - last < 10000) return;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // sessionStorage недоступен — всё равно один раз перезагрузим.
  }
  window.location.reload();
};

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (event) => {
    const msg = event?.message || event?.error?.message;
    if (isChunkLoadError(msg)) reloadOnce();
  });

  window.addEventListener('unhandledrejection', (event) => {
    const msg = event?.reason?.message || String(event?.reason || '');
    if (isChunkLoadError(msg)) reloadOnce();
  });
};
